// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6a51c1bc018ce1c61d1f571808c1a2030b8cc806/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};